import { type GaiaWebSocketResponse, gaiaWsEventBus } from "@expert/gaia";
import type { MessageSuggestion } from "@expert/shared-types";
import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { adaptSimplifiedSummary } from "../deprecated-summary/utils";
import { useSessionSummaryStore } from "../store/useSessionSummaryStore";

export const useSessionSummaryListener = (enabled: boolean) => {
    useEffect(() => {
        const cleanup = gaiaWsEventBus.on("gaia_ws_message-suggestion", ({ body }: GaiaWebSocketResponse) => {
            const transformed = body as MessageSuggestion;
            if (transformed.suggestion.responseType !== "proactive-summary") {
                return;
            }
            const generatedSummary = transformed.suggestion.message;
            const sessionSummaryStore = useSessionSummaryStore.getState();

            if (enabled) {
                const { subject, summary, category, subcategory } = adaptSimplifiedSummary(generatedSummary);
                if (!subject || !summary) {
                    return;
                }
                sessionSummaryStore.setSessionSummary({ value: summary, autoGenerated: true });
                sessionSummaryStore.setSubject(subject);
                if (category) sessionSummaryStore.setCategory(category);
                if (subcategory) sessionSummaryStore.setSubcategory(subcategory);
                void getRootDispatcher().dispatchBusinessEvent("ProactiveSessionSummaryGenerated");
            } else {
                sessionSummaryStore.setSessionSummary({ value: generatedSummary, autoGenerated: true });
            }
        });

        return () => cleanup();
    }, [enabled]);
};
